import { render, staticRenderFns } from "./single-news.vue?vue&type=template&id=ca8a3b3a&scoped=true&"
import script from "./single-news.vue?vue&type=script&lang=js&"
export * from "./single-news.vue?vue&type=script&lang=js&"
import style0 from "./single-news.vue?vue&type=style&index=0&id=ca8a3b3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8a3b3a",
  null
  
)

export default component.exports